module.exports = __webpack_public_path__ + "img/perfil_dorso_plano.ba6b41ad.jpg";